import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { NotificationNavigation } from '@/modules/Notifications/interfaces/NotificationNavigation';
import { RouteNames } from '@/enums/routes/RouteNames';
import { GlobalEntities } from '@/enums/global/GlobalEntities';

interface Props {
    routingData: NotificationNavigation;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomNavLink',
  props: {
    routingData: null
  },
  setup(__props: any) {

const props = __props as {
    routingData: NotificationNavigation;
};



const routeNames = RouteNames;
const globalEntities = GlobalEntities;

const nav = computed(() => props.routingData);

const navTab = computed(() => {
    if (!nav.value.tab) {
        return '';
    }

    switch (nav.value.entity) {
        case 'projects':
            return findProjectTab(nav.value.tab);
        case 'clients':
            return findClientTab(nav.value.tab);
        default:
            return '';
    }
});

const navigationText = computed(() => {
    if (!nav.value) {
        return '';
    }

    switch (nav.value.entity) {
        case 'projects':
            return `Project ${nav.value.id}`;
        case 'clients':
            return `Client ${nav.value.id}`;
        default:
            return 'Check';
    }
});

function findProjectTab(tab: string) {
    switch (tab) {
        case 'basic':
            return '0';
        case 'lead':
            return '1';
        case 'products':
            return '2';
        case 'orders':
            return '3';
        case 'payments':
            return '4';
        default:
            return tab;
    }
}

function findClientTab(tab: string) {
    return tab;
}

return { __sfc: true,props, routeNames, globalEntities, nav, navTab, navigationText, findProjectTab, findClientTab }
}

})